/*
 * Title: Successfull/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Successfully sign up popup.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useSelector } from "react-redux";
import check from "@assets/check.png";
import Icon from "@components/Icon";
import Lottie from 'react-lottie'
import successGif from "@assets/lotties/success.json";

const EarnPopup = (props) => {
  const notifications = useSelector((state: any) => state.user.notifications);

  const [visible, setVisible] = useState(true);
  const [show, setShow] = useState(false);

  const touchpoints = useSelector((state: any) =>
    Object.assign([], state.EarnReward.data?.touchpoints)
  );

  const earnReward = useSelector((state: any) => state.EarnReward.data);

  const pointsRedeemed = useSelector(
    (state: any) => state.score?.points_redeemed || 0
  );

  const pointsEarned =
    (earnReward.touchpoints || []).filter(
      (i) => i.touchpoint.touchpoint === "featured"
    )[0]?.pointsEarned || 0;

  const feature =
    (earnReward.touchpoints || []).filter(
      (i) => i.touchpoint.touchpoint === "featured"
    )[0] || {};

  const actionItem =
    (earnReward.touchpoints || []).filter(
      (i) => i.touchpoint.touchpoint === "featured"
    )[0]?.actionItems?.redeemed?.[0]?.actionItem || {};

    useEffect(() => {
      const showTimer = setTimeout(() => {
        if(notifications.length > 0){
          setShow(true);
          const timer = setTimeout(() => {
            if(notifications.length > 0){
              setVisible(false);
            }
            
          }, 4000);
          return () => clearTimeout(timer);
        }
        
      }, 2000);
      return () => clearTimeout(showTimer);

      
    }, [notifications.length]);

    // const totalScores = notifications.reduce((previousScore:number, currentScore:any)=>previousScore + parseInt(currentScore?.score?.touchpointScore || 0),  0);
    const totalScores = notifications.reduce((previousScore:number, currentScore:any)=>parseInt(currentScore?.score?.redemptionInfo.pointsEarned || 0),  0);

    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: successGif,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
      };

  if (notifications.length > 0 && visible && show) {
    return (
      <Transition.Root show={true} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => true}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-[#000]/80 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative w-screen h-full overflow-hidden pointer-events-auto">
                  <div className="flex flex-col items-center justify-center text-center">
                    <Lottie options={defaultOptions} height={242} width={242} />
                    <>
                      <h4 className="font-medium text-white text-[36px] text-center">
                        You earned {totalScores} points
                      </h4>
                      <p className="text-[18px] mb-[40px] leading-[21.6px] text-[white]/70 font-normal tracking-[1.5px] mt-[10px]">
                        You now have {pointsRedeemed} points available.
                      </p>
                      <>
                        {notifications.map((notification, key) => {
                          const touchpoint =
                            touchpoints.filter(
                              (i) =>
                                i.touchpoint?.id == notification.touchpointId
                            )[0] || {};
                          const notRedeemed =
                            touchpoint?.actionItems?.notRedeemed.filter(
                              (i) => i.id === notification.actionItemId
                            )[0] || {};
                          const redeemed =
                            touchpoint?.actionItems?.redeemed.filter(
                              (i) =>
                                i.actionItem?.id === notification.actionItemId
                            )[0]?.actionItem || {};

                          return (
                            <>
                            {redeemed?.id &&
                            <div className="relative mb-1  w-[300px] sm:w-[420px] md:w-[420px]">
                              {touchpoint?.authorized && (
                                <div className="bg-green rounded-full p-[4px] h-5 w-5 flex items-center justify-center z-10 absolute -left-1 -top-1 overflow-hidden">
                                  <img
                                    src={check}
                                    alt="Check"
                                    className="object-contain w-full h-full"
                                  />
                                </div>
                              )}

                              <div className="bg-tile w-full p-[20px] transition-all duration-700 ease-in-out  rounded-[10px] relative cursor-pointer overflow-hidden">
                                <div className="flex items-center justify-between">
                                  <div className="bg-body opacity-50 p-[8px] rounded-full flex items-center justify-center">
                                    <p
                                      className={`lg:text-[14px] text-[12px] uppercase font-semibold tracking-wider tile-inlay-primary`}
                                    >
                                      {redeemed?.points} POINTS
                                    </p>
                                  </div>
                                  <div className="-mt-1">
                                    <Icon
                                      icon={touchpoint?.touchpoint?.touchpoint}
                                    />
                                  </div>
                                </div>
                                <h4 className="font-medium tile-inlay-primary text-left lg:text-[20px] text-[16px] mt-[15px]">
                                  {redeemed?.title}
                                </h4>
                              </div>
                            </div>}
                            {notRedeemed?.id &&
                            <div className="relative mb-1 w-[300px] sm:w-[420px] md:w-[420px]">
                              {touchpoint?.authorized && (
                                <div className="bg-green rounded-full p-[4px] h-5 w-5 flex items-center justify-center z-10 absolute -left-1 -top-1 overflow-hidden">
                                  <img
                                    src={check}
                                    alt="Check"
                                    className="object-contain w-full h-full"
                                  />
                                </div>
                              )}

                              <div className="bg-tile w-full p-[20px] transition-all duration-700 ease-in-out  rounded-[10px] relative cursor-pointer overflow-hidden">
                                <div className="flex items-center justify-between">
                                  <div className="bg-body opacity-50 p-[8px] rounded-full flex items-center justify-center">
                                    <p
                                      className={`lg:text-[14px] text-[12px] uppercase font-semibold tracking-wider tile-inlay-primary`}
                                    >
                                      {notRedeemed?.points} POINTS
                                    </p>
                                  </div>
                                  <div className="-mt-1">
                                    <Icon
                                      icon={touchpoint?.touchpoint?.touchpoint}
                                    />
                                  </div>
                                </div>
                                <h4 className="font-medium tile-inlay-primary text-left lg:text-[20px] text-[16px] mt-[15px]">
                                  {notRedeemed?.title}
                                </h4>
                              </div>
                            </div>}
                            </>
                          );
                        })}
                      </>
                    </>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    );
  }
  return null;
};
export default EarnPopup;
